import { render } from "./IssuesSelector.vue?vue&type=template&id=cb4b5300&scoped=true"
import script from "./IssuesSelector.vue?vue&type=script&lang=js"
export * from "./IssuesSelector.vue?vue&type=script&lang=js"

import "./IssuesSelector.vue?vue&type=style&index=0&id=cb4b5300&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb4b5300"]])

export default __exports__